import _restoreCursor from "restore-cursor";
import _process from "process";
var exports = {};
var process = _process;
const restoreCursor = _restoreCursor;
let isHidden = false;

exports.show = (writableStream = process.stderr) => {
  if (!writableStream.isTTY) {
    return;
  }

  isHidden = false;
  writableStream.write("\x1B[?25h");
};

exports.hide = (writableStream = process.stderr) => {
  if (!writableStream.isTTY) {
    return;
  }

  restoreCursor();
  isHidden = true;
  writableStream.write("\x1B[?25l");
};

exports.toggle = (force, writableStream) => {
  if (force !== undefined) {
    isHidden = force;
  }

  if (isHidden) {
    exports.show(writableStream);
  } else {
    exports.hide(writableStream);
  }
};

export default exports;
export const show = exports.show,
      hide = exports.hide,
      toggle = exports.toggle;